import { writable } from 'svelte/store'

const MIN_WS_RECONNECT_TIMEOUT = 500
const MAX_WS_RECONNECT_TIMEOUT = 30000

export default class PersistentWebSocket extends EventTarget {
	constructor(url) {
		super()
		this.url = url
		this.doReconnect = true
		const w = writable({
			connected: false,
			url: '',
			reconnectTime: 0
		})
		this.subscribe = w.subscribe
		this.update = w.update
	}

	connect() {
		this.doReconnect = true
		this._reconnect()
	}

	close() {
		this.doReconnect = false
		this.ws.close()
	}

	handleOpen() {
		this.reconnectTimeout = MIN_WS_RECONNECT_TIMEOUT

		this.update(old => {
			old.connected = true
			old.reconnectTime = MIN_WS_RECONNECT_TIMEOUT
			return old
		})
	}

	handleClose(event) {
		if (event.code === 4000) {
			console.log("Server sent a 4000 error code to the websocket.")
			this.doReconnect = false
		}
		this.update(old => {
			old.connected = false
			return old
		})
		this.reconnect()
	}

	handleError(event) {
		console.log("ws error:", event)
	}

	handleMessage(message) {
		if (!message.data) {
			console.error("Got websocket message without data: ", message)
			return
		}
		const event = new CustomEvent("message", { detail: message.data })
		this.dispatchEvent(event)
	}

	reconnect() {
		if (!this.doReconnect) {
			return
		}
		console.log(`Will attempt to reconnect ${this.url} in ${this.reconnectTimeout / 1000}s`)
		setTimeout(() => {
			// Back off the reconnect
			this.reconnectTimeout = this.reconnectTimeout * 2

			if (this.reconnectTimeout > MAX_WS_RECONNECT_TIMEOUT) this.reconnectTimeout = MAX_WS_RECONNECT_TIMEOUT
			this._reconnect()
		}, this.reconnectTimeout)
	}

	async _reconnect() {
		let url = this.url
		if (typeof url === 'function') { url = await url() }

		// console.log("Connecting to ", url)
		this.ws = new WebSocket(url)
		if (!this.reconnectTimeout) this.reconnectTimeout = MIN_WS_RECONNECT_TIMEOUT

		this.update(old => {
			old.url = url
			old.reconnectTime = this.reconnectTimeout
			return old
		})
		this.ws.addEventListener("open", this.handleOpen.bind(this))
		this.ws.addEventListener("close", this.handleClose.bind(this))
		this.ws.addEventListener("error", this.handleError.bind(this))
		this.ws.addEventListener("message", this.handleMessage.bind(this))
	}
}